import React from 'react';
import { motion } from 'framer-motion';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    title: 'Blindaje Digital en 1 Hora',
    desc: 'Plan de acción express. Una tarde y quedás protegido.',
    price: '$9.500'
  }, {
    num: '02',
    title: 'Kit Anti-Estafa Familiar',
    desc: 'Protegé a adultos mayores y adolescentes de tu familia.',
    price: '$8.500'
  }, {
    num: '03',
    title: 'Scripts Blindados',
    desc: 'Respuestas listas para cuando un estafador te contacta.',
    price: '$7.500'
  }, {
    num: '04',
    title: 'Checklist Legal',
    desc: 'Tus derechos como consumidor bancario, paso a paso.',
    price: '$8.000'
  }, {
    num: '05',
    title: 'Antihackeo Mensual',
    desc: 'Ritual de seguridad de 10 minutos que cualquiera puede hacer.',
    price: '$7.000'
  }, {
    num: '06',
    title: 'Mapa de Riesgo Personal',
    desc: 'Auditoría de tus vulnerabilidades actuales.',
    price: '$7.500'
  }];
  return <section className="w-full py-16 px-4 sm:px-6 lg:px-8 flex flex-col items-center" data-id="element-26">
      <div className="max-w-4xl mx-auto w-full" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-28">
          <div className="text-brand-cyan text-[10px] font-bold tracking-[0.3em] uppercase mb-3" data-id="element-29">
            SIEMPRE INCLUIDOS
          </div>
          <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold text-white tracking-tight" data-id="element-30">
            6 Bonos <span className="text-brand-cyan" data-id="element-31">Estratégicos</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-32">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex flex-col p-4 rounded-lg border border-brand-cyan/15 hover:border-brand-cyan/50 hover:shadow-[0_0_30px_rgba(0,212,255,0.15),0_0_60px_rgba(0,212,255,0.05)] transition-all duration-300 cursor-pointer group" style={{
          background: 'linear-gradient(135deg, #0d1333 0%, #0a0f2e 100%)'
        }} data-id="element-33">
              <div className="flex items-center justify-between mb-1.5" data-id="element-34">
                <div className="flex items-center gap-2.5" data-id="element-35">
                  <span className="inline-flex items-center justify-center w-6 h-6 rounded text-[9px] font-extrabold text-black shrink-0 group-hover:shadow-[0_0_12px_rgba(0,212,255,0.5)] transition-shadow duration-300" style={{
                background: 'linear-gradient(135deg, #67e8f9 0%, #00D4FF 50%, #0891b2 100%)'
              }} data-id="element-36">
                    {bonus.num}
                  </span>
                  <h3 className="text-sm font-bold text-white" data-id="element-37">
                    {bonus.title}
                  </h3>
                </div>
                <div className="flex items-center gap-1.5" data-id="element-38">
                  <span className="text-gray-600 line-through text-[10px]" data-id="element-39">
                    {bonus.price}
                  </span>
                  <span className="text-green-400 text-[9px] font-extrabold uppercase tracking-wider border border-green-400/20 bg-green-400/10 px-1.5 py-0.5 rounded" data-id="element-40">
                    Gratis
                  </span>
                </div>
              </div>
              <p className="text-gray-500 text-xs leading-relaxed" data-id="element-41">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-42">
          <div className="inline-flex items-center gap-3 px-8 py-4 rounded-xl border border-green-400/30 animate-pulse" style={{
          background: 'linear-gradient(135deg, rgba(34,197,94,0.08) 0%, rgba(0,212,255,0.05) 100%)',
          boxShadow: '0 0 25px rgba(34,197,94,0.15), 0 0 50px rgba(34,197,94,0.05)'
        }} data-id="element-43">
            <span className="text-sm sm:text-base text-gray-300 font-medium" data-id="element-44">
              Valor total:
            </span>
            <span className="line-through text-red-400/70 text-base sm:text-lg font-bold" data-id="element-45">
              $48.000
            </span>
            <span className="text-brand-cyan text-lg font-bold" data-id="element-46">→</span>
            <span className="text-green-400 text-base sm:text-lg font-extrabold uppercase tracking-wide" style={{
            textShadow: '0 0 12px rgba(34,197,94,0.5)'
          }} data-id="element-47">
              🎁 Gratis hoy
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}